var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniSea01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.532715,
    y: 0.89624,
    width: 258,
    height: 252,
    fill: "#2E4491"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3224_14168",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.532715,
    y: 0.89624,
    width: 258,
    height: 252,
    fill: "#D6895E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3224_14168)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.214 35.1741L131.219 40.9394L131.219 40.9396L151.224 46.7049L151.224 46.7051L171.229 52.4703L127.739 203.374L107.734 197.609L107.734 197.609L87.7294 191.844L87.7295 191.843L67.7246 186.078L111.214 35.1741ZM171.23 52.4684L191.235 58.2337L191.235 58.2344L211.238 63.9992L167.748 214.903L147.743 209.138L147.743 209.137L127.74 203.372L171.23 52.4684ZM231.243 69.7647L211.239 63.9994L167.749 214.903L187.754 220.669L187.754 220.669L207.758 226.434L251.248 75.5302L231.243 69.7649L231.243 69.7647Z",
    fill: "#442B26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.617,
    y: 36.7271,
    width: 20.8191,
    height: 157.046,
    transform: "rotate(16.0767 117.617 36.7271)",
    fill: "#FFE3DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.622,
    y: 42.4968,
    width: 20.8191,
    height: 157.046,
    transform: "rotate(16.0767 137.622 42.4968)",
    fill: "#FF775E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.626,
    y: 48.2625,
    width: 20.8191,
    height: 157.046,
    transform: "rotate(16.0767 157.626 48.2625)",
    fill: "#FFE3DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.632,
    y: 54.0256,
    width: 20.8191,
    height: 157.046,
    transform: "rotate(16.0767 177.632 54.0256)",
    fill: "#FF775E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.642,
    y: 65.5544,
    width: 20.8191,
    height: 157.046,
    transform: "rotate(16.0767 217.642 65.5544)",
    fill: "#FF775E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.636,
    y: 59.7913,
    width: 20.8191,
    height: 157.046,
    transform: "rotate(16.0767 197.636 59.7913)",
    fill: "#FFE3DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.646,
    y: 71.3201,
    width: 20.8191,
    height: 157.046,
    transform: "rotate(16.0767 237.646 71.3201)",
    fill: "#FFE3DE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.784 112.2C196.802 115.484 195.973 121.26 198.872 125.53L224.333 163.045L224.332 163.045C227.654 168.718 235.388 170.365 241.697 166.671C248.006 162.978 250.441 155.378 247.121 149.705L247.124 149.703L225.707 107.443C222.812 101.729 215.366 100.173 210.424 104.249L206.909 107.148L200.784 112.2Z",
    fill: "#442B26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.936 110.827C199.06 114.118 198.271 119.795 201.104 124.018L226.445 161.809L226.447 161.808C229.768 167.481 237.078 169.375 242.858 165.992C248.637 162.608 250.642 155.26 247.321 149.587L247.323 149.587L225.755 107.558C222.813 101.825 215.296 100.33 210.385 104.501L208.065 106.471L202.936 110.827Z",
    fill: "#FFE0DB"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-1_3224_14168",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.936 110.827C199.06 114.118 198.271 119.795 201.104 124.018L226.445 161.809L226.447 161.808C229.768 167.481 237.078 169.375 242.858 165.992C248.637 162.608 250.642 155.26 247.321 149.587L247.323 149.587L225.755 107.558C222.813 101.825 215.296 100.33 210.385 104.501L208.065 106.471L202.936 110.827Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201.104 124.018L201.934 123.461L201.104 124.018ZM202.936 110.827L203.583 111.589L203.583 111.589L202.936 110.827ZM226.445 161.809L225.614 162.366L226.138 163.148L226.95 162.672L226.445 161.809ZM226.447 161.808L227.31 161.303L226.804 160.44L225.941 160.945L226.447 161.808ZM247.321 149.587L246.816 148.724L245.953 149.23L246.458 150.093L247.321 149.587ZM247.323 149.587L247.828 150.45L248.644 149.972L248.212 149.13L247.323 149.587ZM225.755 107.558L226.644 107.101L226.644 107.101L225.755 107.558ZM210.385 104.501L209.737 103.739L210.385 104.501ZM208.065 106.471L207.417 105.709L208.065 106.471ZM201.934 123.461C199.385 119.66 200.095 114.551 203.583 111.589L202.289 110.064C198.025 113.685 197.158 119.929 200.273 124.575L201.934 123.461ZM227.276 161.252L201.934 123.461L200.273 124.575L225.614 162.366L227.276 161.252ZM225.941 160.945L225.94 160.946L226.95 162.672L226.952 162.671L225.941 160.945ZM225.584 162.314C229.189 168.47 237.115 170.513 243.363 166.855L242.353 165.129C237.042 168.238 230.347 166.491 227.31 161.303L225.584 162.314ZM243.363 166.855C249.603 163.202 251.794 155.248 248.185 149.082L246.458 150.093C249.491 155.272 247.672 162.015 242.353 165.129L243.363 166.855ZM246.817 148.724L246.816 148.724L247.827 150.45L247.828 150.45L246.817 148.724ZM224.865 108.014L246.433 150.043L248.212 149.13L226.644 107.101L224.865 108.014ZM211.032 105.263C215.452 101.509 222.217 102.855 224.865 108.014L226.644 107.101C223.408 100.795 215.14 99.1506 209.737 103.739L211.032 105.263ZM208.712 107.233L211.032 105.263L209.737 103.739L207.417 105.709L208.712 107.233ZM203.583 111.589L208.712 107.233L207.417 105.709L202.289 110.064L203.583 111.589Z",
    fill: "#C76553",
    mask: "url(#path-13-inside-1_3224_14168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.823 115.759L213.846 117.607L210.672 140.973L210.091 139.98C208.906 137.954 208.471 135.576 208.862 133.262L211.823 115.759Z",
    fill: "#8D655E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.699 114.657L214.321 117.326L236.25 125.996L235.668 125.002C234.482 122.977 232.621 121.434 230.411 120.643L213.699 114.657Z",
    fill: "#8D655E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.688 113.812L212.381 116.704L210.626 142.294L209.1 139.689C207.95 137.726 207.503 135.428 207.835 133.177L210.688 113.812Z",
    fill: "#FF775E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.688 113.812L212.381 116.704L210.626 142.294L209.1 139.689C207.95 137.726 207.503 135.428 207.835 133.177L210.688 113.812Z",
    fill: "url(#paint0_linear_3224_14168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.381 116.708L210.689 113.816L210.578 114.564C210.629 114.627 211.763 116.578 212.324 117.546L212.381 116.708Z",
    fill: "#753124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.722 155.811C224.026 156.126 224.559 155.913 224.564 155.475V155.475C224.565 155.363 224.528 155.255 224.459 155.167L210.921 137.962L210.617 142.281L223.722 155.811Z",
    fill: "#B44C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.618 142.28L210.921 137.96L211.863 139.157L211.881 143.584L210.618 142.28Z",
    fill: "#753124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.879 144.593C243.004 145.013 242.558 145.374 242.174 145.163V145.163C242.076 145.11 241.999 145.024 241.956 144.921L233.58 124.694L237.495 126.544L242.879 144.593Z",
    fill: "#B44C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.636 112.675L214.329 115.566L237.502 126.563L235.978 123.957C234.829 121.993 233.044 120.479 230.918 119.666L212.636 112.675Z",
    fill: "#FF775E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.636 112.675L214.329 115.566L237.502 126.563L235.978 123.957C234.829 121.993 233.044 120.479 230.918 119.666L212.636 112.675Z",
    fill: "url(#paint1_linear_3224_14168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.328 115.567L212.636 112.675L213.342 112.945C213.372 113.02 214.518 114.964 215.087 115.927L214.328 115.567Z",
    fill: "#753124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.494 126.544L233.579 124.695L234.162 126.102L238.013 128.284L237.494 126.544Z",
    fill: "#753124"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.833,
    y: 112.339,
    width: 2.24842,
    height: 6.74527,
    rx: 1.12421,
    transform: "rotate(-30.3463 209.833 112.339)",
    fill: "#FF7258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.921 161.909L226.969 156.866L228.863 155.757C230.02 155.08 231.048 155.422 231.618 156.389C232.18 157.355 231.966 158.42 230.803 159.101L229.828 159.672L230.827 161.379L229.921 161.909ZM229.391 158.927L230.241 158.43C230.922 158.026 231.004 157.464 230.692 156.931C230.376 156.391 229.851 156.198 229.169 156.598L228.319 157.095L229.391 158.927Z",
    fill: "#F2CBC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.628 159.228C234.328 159.404 233.938 159.305 233.766 159.003C233.591 158.713 233.698 158.328 233.996 158.149C234.287 157.983 234.675 158.079 234.846 158.371C235.021 158.671 234.917 159.059 234.628 159.228Z",
    fill: "#F2CBC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.03 158.333L233.077 153.29L234.972 152.181C236.128 151.504 237.157 151.846 237.727 152.812C238.288 153.779 238.075 154.844 236.911 155.525L235.936 156.096L236.935 157.803L236.03 158.333ZM235.5 155.351L236.35 154.853C237.03 154.45 237.113 153.888 236.801 153.355C236.485 152.815 235.96 152.622 235.277 153.021L234.427 153.519L235.5 155.351Z",
    fill: "#F2CBC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.329 150.215L241.282 155.258L240.39 155.78L237.438 150.737L238.329 150.215Z",
    fill: "#F2CBC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.855 153.854C242.716 154.521 241.572 154.172 240.879 152.988C240.193 151.817 240.439 150.607 241.519 149.975C242.445 149.433 243.587 149.546 244.364 150.872L244.527 151.151L241.887 152.697C242.278 153.333 242.882 153.494 243.454 153.154C243.846 152.929 244.01 152.609 243.992 152.315L244.863 151.805C245.086 152.554 244.733 153.341 243.855 153.854ZM241.535 152.089L243.322 151.043C243.017 150.529 242.448 150.357 241.936 150.657C241.404 150.969 241.285 151.59 241.535 152.089Z",
    fill: "#F2CBC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.202 78.4765C225.384 74.4121 231.136 73.437 235.479 76.2257L273.632 100.722L260.875 123.845L218.082 103.513C212.296 100.765 210.551 93.361 214.499 88.3171L217.308 84.7291L222.202 78.4765ZM260.877 123.845C266.632 127.02 274.168 124.392 277.7 117.991C281.231 111.59 279.387 103.9 273.632 100.725L260.877 123.845Z",
    fill: "#442B26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.165 78.2706C225.357 74.3118 231.011 73.3788 235.306 76.1023L273.731 100.472L273.73 100.472C279.486 103.648 281.566 110.908 278.331 116.772C275.096 122.635 267.801 124.827 262.046 121.652L262.045 121.654L219.479 101.165C213.673 98.3704 211.987 90.8944 216.031 85.8781L217.942 83.5086L222.165 78.2706Z",
    fill: "#FFE0DB"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-29-inside-2_3224_14168",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.165 78.2706C225.357 74.3118 231.011 73.3788 235.306 76.1023L273.731 100.472L273.73 100.472C279.486 103.648 281.566 110.908 278.331 116.772C275.096 122.635 267.801 124.827 262.046 121.652L262.045 121.654L219.479 101.165C213.673 98.3704 211.987 90.8944 216.031 85.8781L217.942 83.5086L222.165 78.2706Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M235.306 76.1023L234.77 76.9468L235.306 76.1023ZM222.165 78.2706L222.943 78.8982L222.165 78.2706ZM273.731 100.472L274.266 99.6273L275.061 100.131L274.606 100.955L273.731 100.472ZM273.73 100.472L273.247 101.348L272.372 100.865L272.855 99.9892L273.73 100.472ZM262.046 121.652L261.17 121.169L261.653 120.293L262.529 120.776L262.046 121.652ZM262.045 121.654L262.92 122.137L262.463 122.966L261.611 122.555L262.045 121.654ZM219.479 101.165L219.045 102.066L219.045 102.066L219.479 101.165ZM216.031 85.8781L215.253 85.2505L216.031 85.8781ZM217.942 83.5086L217.163 82.8809L217.942 83.5086ZM234.77 76.9468C230.905 74.4956 225.816 75.3353 222.943 78.8982L221.386 77.6429C224.897 73.2883 231.117 72.2619 235.841 75.2578L234.77 76.9468ZM273.195 101.316L234.77 76.9468L235.841 75.2578L274.266 99.6273L273.195 101.316ZM272.855 99.9892L272.855 99.9887L274.606 100.955L274.606 100.955L272.855 99.9892ZM274.213 99.5967C280.46 103.043 282.704 110.915 279.207 117.255L277.456 116.289C280.428 110.9 278.511 104.252 273.247 101.348L274.213 99.5967ZM279.207 117.255C275.714 123.585 267.819 125.978 261.563 122.528L262.529 120.776C267.784 123.675 274.478 121.686 277.456 116.289L279.207 117.255ZM261.169 121.171L261.17 121.169L262.921 122.135L262.92 122.137L261.169 121.171ZM219.913 100.264L262.478 120.753L261.611 122.555L219.045 102.066L219.913 100.264ZM216.81 86.5058C213.17 91.0205 214.687 97.7488 219.913 100.264L219.045 102.066C212.659 98.992 210.804 90.7684 215.253 85.2505L216.81 86.5058ZM218.72 84.1362L216.81 86.5058L215.253 85.2505L217.163 82.8809L218.72 84.1362ZM222.943 78.8982L218.72 84.1362L217.163 82.8809L221.386 77.6429L222.943 78.8982Z",
    fill: "#C76553",
    mask: "url(#path-29-inside-2_3224_14168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.322 87.0256L229.222 89.0005L252.499 85.2318L251.491 84.6761C249.436 83.5431 247.048 83.169 244.744 83.6193L227.322 87.0256Z",
    fill: "#8D655E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.275 88.9331L228.958 89.4864L238.184 111.187L237.177 110.631C235.122 109.497 233.532 107.676 232.685 105.487L226.275 88.9331Z",
    fill: "#8D655E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.355 85.9445L228.288 87.5629L253.825 85.1562L251.183 83.6972C249.19 82.5972 246.882 82.2097 244.64 82.5987L225.355 85.9445Z",
    fill: "#FF775E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.355 85.9445L228.288 87.5629L253.825 85.1562L251.183 83.6972C249.19 82.5972 246.882 82.2097 244.64 82.5987L225.355 85.9445Z",
    fill: "url(#paint2_linear_3224_14168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.289 87.5618L225.356 85.9434L226.101 85.8142C226.165 85.8626 228.144 86.9469 229.126 87.483L228.289 87.5618Z",
    fill: "#753124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.666 97.9006C267.988 98.1972 267.789 98.7354 267.351 98.7513V98.7513C267.24 98.7554 267.13 98.7211 267.04 98.6543L249.496 85.5596L253.806 85.1458L267.666 97.9006Z",
    fill: "#B44C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.807 85.1464L249.497 85.5602L250.717 86.4712L255.143 86.3762L253.807 85.1464Z",
    fill: "#753124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.944 117.336C257.367 117.451 257.716 116.995 257.496 116.617V116.617C257.44 116.52 257.352 116.445 257.248 116.405L236.814 108.548L238.763 112.415L256.944 117.336Z",
    fill: "#B44C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.264 87.9193L227.197 89.5377L238.781 112.423L236.137 110.966C234.144 109.867 232.585 108.122 231.719 106.017L224.264 87.9193Z",
    fill: "#FF775E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.264 87.9193L227.197 89.5377L238.781 112.423L236.137 110.966C234.144 109.867 232.585 108.122 231.719 106.017L224.264 87.9193Z",
    fill: "url(#paint3_linear_3224_14168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.198 89.5368L224.265 87.9184L224.553 88.6174C224.628 88.6457 226.601 89.7417 227.578 90.2862L227.198 89.5368Z",
    fill: "#753124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.763 112.415L236.815 108.548L238.236 109.095L240.516 112.89L238.763 112.415Z",
    fill: "#753124"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.24842,
    height: 6.74527,
    rx: 1.12421,
    transform: "matrix(-0.483053 0.875591 0.875591 0.483053 223.858 85.1223)",
    fill: "#FF7258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.201 242.896V223.099H189.966C194.464 223.099 197.048 225.875 197.048 229.771C197.048 233.722 194.423 236.443 189.857 236.443H186.302V242.896H182.201ZM186.302 233.135H189.201C191.634 233.135 192.824 231.767 192.81 229.771C192.824 227.802 191.634 226.476 189.201 226.463H186.302V233.135ZM201.013 243.142C199.728 243.142 198.689 242.117 198.716 240.845C198.689 239.588 199.728 238.562 201.013 238.576C202.23 238.562 203.283 239.588 203.283 240.845C203.283 242.117 202.23 243.142 201.013 243.142ZM206.619 242.896V223.099H214.384C218.882 223.099 221.466 225.875 221.466 229.771C221.466 233.722 218.841 236.443 214.275 236.443H210.72V242.896H206.619ZM210.72 233.135H213.619C216.052 233.135 217.242 231.767 217.228 229.771C217.242 227.802 216.052 226.476 213.619 226.463H210.72V233.135ZM228.029 223.099V242.896H223.982V223.099H228.029ZM237.9 243.197C233.347 243.183 230.558 240.244 230.572 235.541C230.558 230.961 233.388 227.857 237.736 227.857C241.632 227.857 244.708 230.318 244.708 235.377V236.525H234.564C234.564 238.767 235.89 240.148 237.982 240.162C239.363 240.148 240.347 239.547 240.744 238.658H244.599C244.025 241.406 241.564 243.183 237.9 243.197ZM234.564 233.982H240.88C240.867 232.177 239.623 230.879 237.818 230.892C235.958 230.879 234.646 232.273 234.564 233.982Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3224_14168",
    x1: 210.688,
    y1: 113.812,
    x2: 213.859,
    y2: 139.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#753124",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3224_14168",
    x1: 218.869,
    y1: 109.026,
    x2: 231.271,
    y2: 130.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B44C38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3224_14168",
    x1: 225.354,
    y1: 85.9449,
    x2: 251.372,
    y2: 88.4526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#753124",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3224_14168",
    x1: 220.775,
    y1: 94.2433,
    x2: 242.269,
    y2: 106.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B44C38",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniSea01);
export default __webpack_public_path__ + "static/media/mini_sea_01.6afe6f9ddaab3a21b92bbb58bbae7eb3.svg";
export { ForwardRef as ReactComponent };